import { useStore } from "@/state/store";

let logoutInFlight: Promise<void> | null = null;

export function performClientLogout(reason: string): Promise<void> {
  if (logoutInFlight) return logoutInFlight;

  logoutInFlight = (async () => {
    const { auth, crypto: coreCrypto, encodeBase64 } = await import("@/core_bridge/module_api");
    const { disconnect: disconnectWebSocket } = await import("@/transport/webSocketService");

    disconnectWebSocket();

    try {
      await auth.logout();
    } catch (err) {
      console.warn("[logout] core logout failed", err);
    }

    const { filesystem, db, router } = await import("@/services/module_api");

    try {
      await db.clearAll();
    } catch (err) {
      console.warn("[logout] failed to clear local database", err);
    }

    try {
      await filesystem.clearAll();
    } catch (err) {
      console.warn("[logout] failed to clear filesystem", err);
    }

    try {
      const kp = coreCrypto.boxKeypair();
      const publicKeyBase64 = encodeBase64(kp.public_key);
      const secretKeyBase64 = encodeBase64(kp.secret_key);
      await db.updateKeyPair(publicKeyBase64, secretKeyBase64);
    } catch (err) {
      console.warn("[logout] failed to regenerate keypair", err);
    }

    const { resetInitState } = await import("@/app/module_api");
    resetInitState();

    const { stateServices } = await import("@/state/module_api");
    stateServices.userDirectory.clear();
    stateServices.avatarCache.clear();

    const store = useStore.getState();
    store.logout();
    store.clearUsers();
    store.clearProfilePhotos();
    store.clearGroups();
    store.clearCommunities();
    store.clearThreadRuntimeState();

    console.info("[logout] completed", { reason });
    router.navigate("/welcome", { replace: true });
  })().finally(() => {
    logoutInFlight = null;
  });

  return logoutInFlight;
}
